import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './language/zh'
import zhs from './language/zhs'
import en from './language/en'
import ja from './language/ja'

Vue.use(VueI18n)
function welcomeMessage() {
    let language = window.localStorage.getItem('language');
    if (language === 'English') return 'en';
    if (language === '简体中文') return 'zh';
    if (language === '日本語') return 'ja';
    return 'zhs';
}
const locale = welcomeMessage()
const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en,
        zh,
        zhs,
        ja
    }
})

export default i18n
